import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-heroes',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  title = 'Главная';

  public constructor(
    private titleService: Title
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts